import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { UserService } from "../../../services/user/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RaceOffModel } from "../../../models/race-off.model";
import { DatetimeService } from "../../../services/common/datetime.service";

@Component({
  selector: "app-race-off-list-item",
  templateUrl: "./race-off-list-item.component.html",
  styleUrls: ["./race-off-list-item.component.scss"],
})
export class RaceOffListItemComponent implements OnInit {
  hasError = false;

  @Input() raceOff: RaceOffModel;
  @Input() id: number;
  @Output() raceSelected: EventEmitter<RaceOffModel> =
    new EventEmitter<RaceOffModel>();

  intervalSoonLimit = 2592000; // limite  en secondes  à partir de laquelle on passe en mode warning (30 jours)
  intervalImminentLimit = 432000; // limite de jour à partir de laquelle on passe en mode danger (5 jours)
  intervalToRace!: number;
  intervalToRaceLabel: string;
  intervalToRacePrefix: string;

  constructor(
    protected userService: UserService,
    private datetimeService: DatetimeService
  ) {}

  ngOnInit(): void {
    this.getIntervalToRace(this.raceOff);
  }

  /** Retourne l'échéance
   *
   * @param date
   * @returns {number}
   */
  getIntervalToRace(race: RaceOffModel) {
    const fullRaceDepartureDate = race.date;

    this.intervalToRace = this.datetimeService.getIntervalToToday(
      fullRaceDepartureDate,
      "seconds"
    );

    const label = this.getIntervalLabel(this.intervalToRace);
    this.intervalToRaceLabel = label.intervalLabel;
    this.intervalToRacePrefix = label.intervalPrefix;
  }
  /**
   *
   * @param date
   * @returns {string}
   */
  getIntervalLabel(intervalInSeconds: any) {
    return this.datetimeService.getIntervalLabel(intervalInSeconds);
  }
}
